import * as React from "react";
import "./styles.scss";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import { useState } from "react";
import classNames from "classnames";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const dotArrow = require("../../assets/icon/dot_arrow.svg").default;

interface PaymentSystemChangeInfoProps {
    differenceFromIAP: number;
}

const PaymentSystemChangeInfoPage = (
    props: PaymentSystemChangeInfoProps
): JSX.Element => {
    const [isVisible, setIsVisible] = useState(false);
    const handleOnClick = () => {
        setIsVisible(!isVisible);
    };
    const closableContent = () => {
        return (
            <section className="cancel-flow-wrapper">
                <div className="cancel-flow">
                    <div className="title">
                        iPhoneの設定から
                        <br />
                        ご自身のユーザーアカウントを選択
                    </div>
                    <div className="sign-in-hint">
                        サインイン画面が表示された場合は、パスワード入力、またはTouch
                        ID（指紋認証）やFace ID（顔認証）でサインインします。
                    </div>
                    <div className="arrow-wrapper">
                        <img src={dotArrow} />
                    </div>
                    <div>サブスクリプションを選択</div>
                    <div className="arrow-wrapper">
                        <img src={dotArrow} />
                    </div>
                    <div>パートナーエージェントAppを選択</div>
                    <div className="arrow-wrapper">
                        <img src={dotArrow} />
                    </div>
                    <div>
                        サブスクリプションの編集から
                        <br />
                        <span className="emphasis">
                            サブスクリプションをキャンセルする
                        </span>
                        を選択
                    </div>
                </div>
                <aside className="no-solve">
                    <div>
                        上記のフローで解決しない場合
                        <br />
                        <a
                            href="https://support.apple.com/ja-jp/HT202039"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Appleのサポートページ
                        </a>
                        をご参照ください
                    </div>
                </aside>
            </section>
        );
    };
    return (
        <MainLayout>
            <Headline>
                <span>
                    「Apple サブスクリプション」から
                    <br />
                    「クレジットカード決済」
                    <br />
                    に変更した場合の、
                    <br />
                    決済システム切り替えのタイミング
                </span>
            </Headline>
            <section className="payment-change-info">
                <div className="payment-change-info-text">
                    サブスクリプションが終了した
                    <br />
                    翌日より自動で適用されます。
                </div>
                <div className="payment-change-info-text">
                    すぐにお申し込みいただいても、
                    <br />
                    二重に課金されることはございません。
                </div>
                <div className="flow">
                    <div className="todo">
                        <ul>
                            <li>クレジットカード決済に変更</li>
                            <li>Apple サブスクリプションを解約</li>
                        </ul>
                    </div>
                    <div className="schematic">
                        <span className="start">
                            サブスクリプション
                            <br />
                            での支払い
                        </span>
                        <span className="switch">
                            クレジットカード
                            <br />
                            での課金が開始
                        </span>
                        {props.differenceFromIAP > 0 && (
                            <div className="balloon">
                                月額
                                <span className="text-l">
                                    {props.differenceFromIAP.toLocaleString(
                                        "ja-JP"
                                    )}
                                </span>
                                円<br />
                                お得！
                            </div>
                        )}
                    </div>
                    <div className="switch_timing">
                        <p>サブスクリプション終了日</p>
                    </div>
                </div>
                <div className="accordion-open">
                    <div
                        className={classNames({
                            toggle: true,
                            open: isVisible
                        })}
                        onClick={handleOnClick}
                    >
                        サブスクリプションの解約方法
                    </div>
                </div>
            </section>

            {isVisible ? closableContent() : null}
        </MainLayout>
    );
};

export default PaymentSystemChangeInfoPage;
